import { Client, Controller, Endpoint, mapUrl } from "@/repository";
import { AgentWorkload } from "../models/workload";

export const agentTotalWorkloadQueryKey = "agentTotalWorkload";
export const agentWorkloadQueryKey = "agentWorkload";

export const getAgentWorkload = (agentId: string): Promise<AgentWorkload> =>
	Client.instance.get<AgentWorkload>(
		mapUrl(Controller.Agents, agentId, Endpoint.Workload)
	);

export const getAgentTotalWorkload = (): Promise<number> => {
	return Client.instance.get<number>(
		mapUrl(Controller.Agents, "me", Endpoint.TotalWorkload)
	);
};
